/**
 *
 */

import React from 'react';
import styled from 'styled-components';
import { Row, Col, Timeline } from 'antd';
import LandingContainer from '../../../components/LandingContainer';
import { SubTitle } from '../../../components';

const StyledTimeline = styled.section`
  padding:100px 0px;
  .ant-timeline.ant-timeline-alternate .ant-timeline-item-right .ant-timeline-item-content, .ant-timeline.ant-timeline-right .ant-timeline-item-right .ant-timeline-item-content {
      width: calc(50% - 5%);
      text-align: left;
  }
  .ant-timeline.ant-timeline-alternate .ant-timeline-item-left .ant-timeline-item-content, .ant-timeline.ant-timeline-right .ant-timeline-item-left .ant-timeline-item-content {
      left: calc(50% - -3%);
      width: calc(50% - 14px);
  }
  .ant-timeline-item-last > .ant-timeline-item-tail {
      display: block;
  }
  .ant-timeline{
    .ant-timeline-item-head{
      top: 40%;
      width: 8px;
      height: 8px;
      &:after{
        content:'';
        background: ${(props) => props.theme.webGray};
      height: 30px;
      width: 1px;
      z-index: 9;
      position: absolute;
      bottom: 6px;
      left: 2px;
      right: 0;
      }
      &:before{
        content:'';
        background: ${(props) => props.theme.webGray};
      height: 30px;
      width: 1px;
      z-index: 9;
      position: absolute;
      top: 6px;
      left: 2px;
      right: 0;
      }
      &.ant-timeline-item-head-blue{
        background: ${(props) => props.theme.LandingBlack};
        border-color: ${(props) => props.theme.LandingBlack};
      }
    }
    .ant-timeline-item-tail{
      border-left: 1px solid ${(props) => props.theme.primaryColor};
      height: 100%;
    }
    .ant-timeline-item-content{
      background: ${(props) => props.theme.whiteColor};
      box-shadow: 3px 3px 20px #24415D0F;
      padding: 50px;
      border-radius: 15px;
      h2{
        color: ${(props) => props.theme.primaryColor} !important;
        font-family: 'Mulish',sans-serif !important;
        font-size: 26px;
        font-weight: 700;
      }
      p{
        color: ${(props) => props.theme.LandingBlack};
      }
    }
  }
`;

function AboutTimeline() {
  return (
    <StyledTimeline>
      <LandingContainer>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center padding-b-4">
            <SubTitle fontWeight="900" className="font-20">
              The journey of a thousand steps starts with the first step and <br />
              similarly ROME was not built in a day is how we started as well.
            </SubTitle>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center padding-b-4">
            <SubTitle fontWeight="900" className="font-20">Zaggle’s History</SubTitle>
          </Col>
          <Col xs={24} sm={24} md={3} lg={3} xl={3} />
          <Col xs={24} sm={24} md={18} lg={18} xl={18}>
            <Timeline mode="alternate">
              <Timeline.Item>
                <h2>2011</h2>
                <p>Kickstart of an idea whose time has come.</p>
              </Timeline.Item>
              <Timeline.Item>
                <h2>2012</h2>
                <p>Avinash Godkhindi Joins as CEO of Zaggle.</p>
              </Timeline.Item>
              <Timeline.Item>
                <h2>2013</h2>
                <p>Zaggle wins the Global Prepaid Exchange Award for the Start-Up of the year.</p>
              </Timeline.Item>
              <Timeline.Item>
                <h2>2015</h2>
                <p>Zaggle launches Zaggle app and starts focusing on Loyalty and Cashback.</p>
              </Timeline.Item>
              <Timeline.Item>
                <h2>2017</h2>
                <p>Signs up Jasprit Bumrah, Hardik Pandya, and Md.Siraj as Brand Ambassadors.</p>
              </Timeline.Item>
              <Timeline.Item>
                <h2>2018</h2>
                <p>Launches the Zaggle corporate website and Employee benefits and Expense Management platform.</p>
              </Timeline.Item>
              <Timeline.Item>
                <h2>2019</h2>
                <p>Zaggle launches Reward, Recognition & Engagement Platform PROPEL and Expense Management Card powered by IndusInd bank.</p>
                <p>Zaggle has been recognized as Best B2B Enterprise Product 2019.</p>
              </Timeline.Item>
              <Timeline.Item>
                <h2>2020</h2>
                <p>Zaggle wins the best FinTech Corporate Innovation Program Award at The Economic Times BFSI Innovation Tribe 2020.</p>
              </Timeline.Item>
              <Timeline.Item>
                <h2>2022</h2>
                <p>Zaggle launches Zoyer to simplify and automate business to business payments for enterprises and SMEs.​</p>
              </Timeline.Item>
            </Timeline>
          </Col>
          <Col xs={24} sm={24} md={3} lg={3} xl={3} />
        </Row>
      </LandingContainer>
    </StyledTimeline>
  );
}

export default AboutTimeline;



// WEBPACK FOOTER //
// client/containers/StaticPages/AboutUS/Timeline.js